import { app } from '../../../../../../app';
import { Controller } from './remove-account-owner.controller';

app.component('companyUserDirectoriesManageAccountRemoveOwner', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./remove-account-owner.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/owner/remove/remove-account-owner.component.js